import { apiConstants } from './shared/config';

const routes = [
    {
        path: `/${apiConstants.code}/home`,
        name: `${apiConstants.code}.home`,
        component: () => import( /* webpackPrefetch: true */ /* webpackChunkName: "cosec-home" */ './views/home.vue'),
        meta: {
            auth: undefined,
            title: 'Home',
        }
    },
];

export default routes;